import React, { Component } from 'react';

import UploadFile from '@comm/upload/UploadFile';

class Test extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <UploadFile type="ghost" handleUpload={{}} fileList={[]} />;
  }
}

export default Test;



// WEBPACK FOOTER //
// ./src/components/Test.js